import { t } from '../../../../translations'
import { images } from '../../assets/order-creation'

export const sendForReviewPage = {
  title: t('order_creation_onboarding.send_for_review_title'),
  content: [
    { image: { src: images.sendForReviewImg, className: 'Onboarding__bigImg' } },
    { description: t('order_creation_onboarding.send_for_review') },
  ],
}
